export enum ConfigMode {
    Single = "single",
    Multiple = "multiple",
}
